__turbopack_context__.v({
  "input": "HIKzNW_input",
  "label": "HIKzNW_label",
});
